import { AiFieldDetectionStatusEnum, Documentation } from 'graphql-common';

// Whether any AI-detected field on this document is still in flight
// (QUEUED/DETECTING) — used to know when to keep watching the session-wide
// backgroundJobProgress feed for a live refetch (BE guide §7/§9).
export default function isDocumentDetecting(
  doc: Pick<Documentation, 'aiDetectionStatus'> | null | undefined,
): boolean {
  return (doc?.aiDetectionStatus || []).some(
    (entry) =>
      entry.status === AiFieldDetectionStatusEnum.Queued ||
      entry.status === AiFieldDetectionStatusEnum.Detecting,
  );
}
